import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../store/slices/sessionSlice';

interface Auth0ProviderWithHistoryProps {
    children: ReactNode;
}

interface Auth0AppState {
    returnTo?: string;
}

const Auth0ProviderWithHistory = ({ children }: Auth0ProviderWithHistoryProps) => {
    const domain = import.meta.env.VITE_AUTH0_DOMAIN as string;
    const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string;
    const audience = import.meta.env.VITE_AUTH0_AUDIENCE as string;

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user, isAuthenticated } = useAuth0();

    const onRedirectCallback = (appState?: Auth0AppState) => {
        navigate(appState?.returnTo || window.location.pathname);
        window.history.replaceState({}, document.title, window.location.pathname);
    };

    useEffect(() => {
        if (isAuthenticated && user) {
            // console.log('User Info:', {
            //     id: user.sub,
            //     name: user.name,
            //     email: user.email
            // });

            dispatch(setUser({
                id: user.sub || '',
                user_name: user.name || user.given_name || user.nickname || null,
                email: user.email || null
            }));
        }
    }, [isAuthenticated, user, dispatch]);

    if (!domain || !clientId || !audience) {
        console.error('Missing Auth0 environment variables');
        return null;
    }

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            onRedirectCallback={onRedirectCallback}
            authorizationParams={{
                audience: audience,
                scope: 'openid profile email offline_access',
                redirect_uri: window.location.origin,
            }}
            useRefreshTokens={true}
            useRefreshTokensFallback={true}
            cacheLocation="localstorage"
        >
            {children}
        </Auth0Provider>
    );
};

export default Auth0ProviderWithHistory;
